import React from 'react';
import { connect } from "react-redux";
import getProviderInfo from '../../../API/Provider/GetOneProvider'
import Loader from '../../../Global/loader'
import Tabs from './tabs.js'
import logout from '../../../Global/logout'
import history from '../../../history';

export class ProviderDetails extends React.Component{
	constructor(props) {
		super(props);
	
		this.state={
            loading: true
		} 
	}

    componentDidMount = async () => {
        this.setState({
            loading: true
        })
        
        let url = history.location.pathname
        let urldivided = url.split(":")
        let info = await getProviderInfo(urldivided[1])
        
        console.log(info)
        if(info.error !== null){
            logout()
        }

        await this.props.mapState("MAP_ONE_PROVIDER_DETAILS", info.data.data)

        await this.setState({    
            loading: false    
        })
    }
    
    goBack(){
        history.goBack();
    }

    render(){  
      
        return(  
            this.state.loading ?
                <Loader />
            :  
            <main>    
                <Tabs />
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProviderDetails);
